import { GA4Event} from "./GA4Event";

export function buildCompleteSale(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("complete_sale", {
		items_in_box: attributes.items_in_box || '',
		interaction: attributes.interaction || '',
		total_rebuy_price: attributes.total_rebuy_price || '',
		sale_contains_declined_items: attributes.sale_contains_declined_items || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
